<template>
    <v-container fluid class="divs">
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Yards By Terminal
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-col cols="4">
                            <v-combobox
                                label="Select Terminal"
                                dense
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="terminal"
                                @change="chargeData()"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="2">
                            <v-combobox
                                v-model="yard"
                                :items="yards"
                                :item-text="'Yard'"
                                :item-value="'id'"
                                label="Yard"
                                dense
                                :rules="[v => !!v || 'Yard is required']"
                                auto-select-first
                                append-outer-icon="mdi-content-save"
                                @click:append-outer="validate"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                </v-form>
                <v-data-table dense :headers="headers" :items="yardsTable">
                    <template v-slot:item.Active="{ item }">
                        <v-icon
                            >mdi-{{
                                item.Active
                                    ? 'check-circle-outline'
                                    : 'close-circle-outline'
                            }}</v-icon
                        >
                    </template>
                    <template v-slot:item.Action="{ item }">
                        <v-btn color="red" icon @click="deleteYard(item)"
                            ><v-icon>mdi-delete</v-icon></v-btn
                        >
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            terminals: [],
            terminal: [],
            yardsTable: [],
            yards: [],
            yard: [],
            headers: [
                { text: 'Yard', value: 'Yard' },
                { text: 'Address', value: 'Address' },
                { text: 'City', value: 'City' },
                { text: 'Province', value: 'Province' },
                { text: 'Active', value: 'Active' },
                { text: 'Action', value: 'Action' }
            ]
        };
    },
    mounted() {
        this.loadTerminals();
        this.loadYards();
    },
    methods: {
        loadTerminals: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        chargeData: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal-yard/by/' + this.terminal.id)
                .then(response => {
                    this.yardsTable = response.data;
                    console.log(this.yards);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadYards: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('yard/active')
                .then(response => {
                    this.yards = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate: async function() {
            var str = this.$store;
            if (this.terminal.id == undefined || this.terminal.id == null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select a Terminal'
                });
            } else if (this.yard.id == undefined || this.yard.id == null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select a Yard'
                });
            } else {
                var exist = await this.yardsTable.findIndex(x => {
                    return x.YardId == this.yard.id;
                });
                if (exist >= 0) {
                    str.dispatch('setSnackbar', {
                        color: '#e6ac00',
                        text: 'This yard is already registered'
                    });
                } else {
                    console.log('Assing');
                    this.addYard();
                }
            }
        },
        addYard: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Terminal: this.terminal.id,
                Yard: this.yard.id
            };
            axios
                .post('terminal-yard', parms)
                .then(response => {
                    console.log(response.data);
                    this.chargeData();
                    this.yard.length = 0;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteYard: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .delete('terminal-yard/' + itm.TermyardsID)
                .then(response => {
                    console.log(response.data);
                    this.chargeData();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>

<style>
.divs {
    margin-top: 0px;
    padding-top: 0px;
}

.chps {
    width: 10px;
}
</style>
